/*
Adapted from https://github.com/xiaokaike/vue-color

The MIT License (MIT)

Copyright (c) 2015 greyby

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
 */
import { TinyColor } from "@ctrl/tinycolor";
function _colorChange(data, oldHue) {
    let color;
    let alpha;
    let h = oldHue || 0;
    let source;
    if (data) {
        if (typeof data === "string") {
            color = new TinyColor(data);
            source = color.format;
        }
        else if ("hsl" in data) {
            alpha = data?.a;
            // hsl is better than hex between conversions
            if (data && data.hsl) {
                color = new TinyColor(data.hsl);
            }
            else if (data && data.hex && data.hex.length > 0) {
                color = new TinyColor(data.hex);
            }
            else if (data && data.hsv) {
                color = new TinyColor(data.hsv);
            }
            else if (data && data.rgba) {
                color = new TinyColor(data.rgba);
            }
            h = (data.hsl && data.hsl.h) || h;
            source = data.source;
        }
        else if (data) {
            if (data.source === "hex") {
                color = new TinyColor(data.hex);
            }
            else {
                color = new TinyColor(data);
            }
            source = data.source;
        }
    }
    else {
        color = new TinyColor("white");
    }
    if (color && (color.a === undefined || color.a === null)) {
        color.setAlpha(alpha || 1);
    }
    const hsl = color.toHsl();
    const hsv = color.toHsv();
    if (hsl.s === 0) {
        hsv.h = hsl.h = h;
    }
    /* --- comment this block to fix #109, may cause #25 again --- */
    // when the hsv.v is less than 0.0164 (base on test)
    // because of possible loss of precision
    // the result of hue and saturation would be miscalculated
    // if (hsv.v < 0.0164) {
    //   hsv.h = data.h || (data.hsv && data.hsv.h) || 0
    //   hsv.s = data.s || (data.hsv && data.hsv.s) || 0
    // }
    // if (hsl.l < 0.01) {
    //   hsl.h = data.h || (data.hsl && data.hsl.h) || 0
    //   hsl.s = data.s || (data.hsl && data.hsl.s) || 0
    // }
    /* ------ */
    return {
        hsl: hsl,
        hex: color.toHexString().toUpperCase(),
        hex8: color.toHex8String().toUpperCase(),
        rgba: color.toRgb(),
        hsv: hsv,
        oldHue: oldHue || hsl.h,
        source,
        a: color.getAlpha(),
    };
}
export default {
    props: ["value"],
    data() {
        return {
            val: _colorChange(this.value),
        };
    },
    computed: {
        colors: {
            get() {
                return this.val;
            },
            set(newVal) {
                this.val = newVal;
                this.$emit("input", newVal);
            },
        },
    },
    watch: {
        value(newVal) {
            this.val = _colorChange(newVal);
        },
    },
    methods: {
        colorChange(data, oldHue) {
            this.oldHue = this.colors.hsl.h;
            this.colors = _colorChange(data, oldHue || this.oldHue);
        },
        colorChangeNoEmit(data, oldHue) {
            this.oldHue = this.colors.hsl.h;
            this.val = _colorChange(data, oldHue || this.oldHue);
        },
        isValidHex(hex) {
            return new TinyColor(hex).isValid;
        },
        simpleCheckForValidColor(data) {
            const keysToCheck = ["r", "g", "b", "a", "h", "s", "l", "v"];
            let checked = 0;
            let passed = 0;
            for (let i = 0; i < keysToCheck.length; i++) {
                const letter = keysToCheck[i];
                if (data[letter]) {
                    checked++;
                    if (!isNaN(data[letter])) {
                        passed++;
                    }
                }
            }
            if (checked === passed) {
                return data;
            }
        },
        paletteUpperCase(palette) {
            return palette.map((c) => c.toUpperCase());
        },
        isTransparent(color) {
            return new TinyColor(color).getAlpha() === 0;
        },
    },
};
